import { ElementUI } from '../types/interfaces';

type VisibilityClassesMap = Record<string, boolean>;

export function transformVisibilityArrayToMap(
  visibilityArray: ElementUI[]
): VisibilityClassesMap {
  const visibilityMap: VisibilityClassesMap = {};
  visibilityArray.forEach((item) => {
    if (item.code !== undefined) {
      visibilityMap[item.code] = item.visible;
    }
  });
  return visibilityMap;
}

export const generateStyleRules = (
  visibilityClasses: VisibilityClassesMap,
  roles: string[]
) => {
  return roles
    .map((role) => {
      const isVisible =
        visibilityClasses['wholeui__roles'] || visibilityClasses[role];
      return isVisible ? `.${role} { display: flex !important; }` : '';
    })
    .join(' ');
};
